import {Injectable} from '@angular/core';
import {AppConfigService} from '../services/appConfig.service';

@Injectable()
export class TaixiuServices {
    constructor(private configService: AppConfigService) {}

    diceBet(data = {}, nav: any) {
        data["action"] = 'dice_bet';
        return this.configService.getTaiXiu(data, nav);
    }

    diceInit(data = {}, nav: any) {
        data["flag"] = 'K31Bean';
        return this.configService.getTaiXiuInit(data, nav);
    }

    mDiceInit(data = {}, nav: any) {
        data["flag"] = 'init';
        return this.configService.getTaiXiu1PhutInit(data, nav);
    }

    mDiceBet(data = {}, nav: any) {
        data["flag"] = 'bet';
        return this.configService.getTaiXiu1PhutInit(data, nav);
    }
    mDiceHistory(data = {}, nav: any) {
        data["flag"] = 'getbetcodehistory';
        return this.configService.getTaiXiu1PhutInit(data, nav);
    }
    mDiceHistoryTop(data = {}, nav: any) {
        data["flag"] = 'getopencodehistory';
        return this.configService.getTaiXiu1PhutInit(data, nav);
    }
}



// WEBPACK FOOTER //
// ./src/services/taixiu.services.ts